// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectReportTypeMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_REPORT_TYPE_MESSAGE);
        this.name = null;
        this.id = 0;
        this.accessType = 0;
        this.parameters = [];
    }
}
